<template>
  <div>
    <material-card class="v-card-profile">
      <v-avatar
        slot="offset"
        class="mx-auto d-block"
        size="130">
        <img :src="user.profile.avatar">
      </v-avatar>
      <v-card-text class="text-xs-center">
        <v-flex v-if="user.profile.is_agency" xs12 md6 offset-md3 class="agency pt-1 pb-1 mb-2"><v-img  contain height="20" :src="$http.defaults.storageURL + 'agency.png'"></v-img></v-flex>
        <h6 class="category text-gray font-weight-thin mb-3">{{roles}}</h6>
        <h4 class="card-title">{{user.profile.name}}</h4>
        <h5 class="card-title font-weight-light">{{user.email}}</h5>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-layout column class="text-xs-center">
              <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Users.model.barcode')}}</label>
              <p>{{user.barcode}}</p>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4>
            <v-layout column class="text-xs-center">
              <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Users.model.started_working')}}</label>
              <p class="card-description font-weight-light">{{getLocaleDateFormat(user.profile.started_working)}}</p>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4>
            <v-layout column class="text-xs-center">
              <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Users.model.last_login')}}</label>
              <p class="card-description font-weight-light">{{user.last_login}}</p>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="mt-3">
          <v-flex xs12 md4>
            <v-layout column class="text-xs-center">
              <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Users.model.address')}}</label>
              <p>{{user.profile.address}}</p>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4>
            <v-layout column class="text-xs-center">
              <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Users.model.jmbg')}}</label>
              <p class="card-description font-weight-light">{{user.jmbg}}</p>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4>
            <v-layout column class="text-xs-center">
              <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Users.model.birthday')}}</label>
              <p class="card-description font-weight-light">{{getLocaleDateFormat(user.profile.birthday)}}</p>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="mt-3">
          <v-flex xs12 md4>
            <v-layout column class="text-xs-center">
              <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Users.model.phone')}}</label>
              <p class="card-description font-weight-light">{{user.profile.phone}}</p>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4>
            <v-layout column class="text-xs-center">
              <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Users.model.contract')}}</label>
              <p class="card-description font-weight-light">{{user.profile.contract}}</p>
            </v-layout>
          </v-flex>
          <v-flex xs12 md4>
            <v-layout column class="text-xs-center">
              <label class="text-primary font-weight-thin mb-1">{{$t('Pages.Users.model.patron_saint')}}</label>
              <p class="card-description font-weight-light">{{getLocaleDateFormat(user.profile.patron_saint)}}</p>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-btn v-if="edit" color="warning" round class="font-weight-light" :to="'/users/' + user.id + '/update'">{{$t('Core.Fields.edit')}}</v-btn>
        <v-btn v-if="edit" color="error" round class="font-weight-light" @click="showEquipmentReturnModal = true">{{$t('Core.Fields.equipment_return')}}</v-btn>
        <v-btn v-if="edit" round class="font-weight-light" href="javascript:history.go(-1)">{{$t('Core.Fields.back')}}</v-btn>
      </v-card-text>
    </material-card>

    <equipment-return-modal v-model="showEquipmentReturnModal" :userId="this.$route.params.id" @close="showEquipmentReturnModal = false"></equipment-return-modal>
  </div>
</template>

<script>
    import _ from 'lodash';
    import EquipmentReturnModal from './EquipmentReturnModal'

    export default {
        components: {EquipmentReturnModal},
        props: {
            user: {
                type: Object,
                required: true
            },
            edit: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
          showEquipmentReturnModal: false
        }),
        computed: {
          roles(){
              return _.join(_.map(this.user.roles, 'name'), ' / ');
          }
        },
        created () {

        },
        methods: {
        }
    }
</script>

<style scoped>
  .agency{
    background: linear-gradient(160deg, rgba(151,27,38,0.94) 0%, rgba(206,32,53,0.93) 50%);
  }
</style>
